import { Component, OnInit } from '@angular/core';
import {AnnualFeeInfoModel, CardActivityInfoModel, CardActivityType} from "../../dto/cardInfoModelBase";
import {CardsService} from '../services/cards.service';
import {RoleService} from '../../services/role.service';
import {FormControl} from '@angular/forms';
import {Company} from '../../dto/company';
import {CompanyService} from '../services/company.service';
import {
  AuthenticationMethod,
  CardDataInputMethod,
  CardholderPresent,
  CardPresent, GPSPosData,
  parseGPSPosData,
  SCATestResult
} from "../../helpers/gps-pos-data-helper";

@Component({
  selector: 'app-last-card-activities',
  templateUrl: './last-card-activities.component.html',
  styleUrls: ['./last-card-activities.component.css']
})
export class LastCardActivitiesComponent implements OnInit {

  public list: CardActivityInfoModel[] = [];
  public isLoading = false;

  public companySelect = new FormControl();
  public companies: Company[];
  public start = 0;
  public count = 500;
  public str = '';
  company: Company|null = null;
  companiesFilter: string[] = null;

  constructor(
    private cardsService: CardsService,
    private roleService: RoleService,
    private companyService: CompanyService
  ) { }

  cardActivityType = CardActivityType;

  onCompanyChange() {
    this.triggerSearch();
  }

  triggerSearch() {
    this.onSearch(this.isLoading);
  }

  onSearch(invalid: boolean) {
    this.searchTransactions();
  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  clearFilter() {
    this.start = 0;
    this.count = 500;
    this.companySelect = null;
  }

  searchTransactions() {
    this.isLoading = true;

    if( this.count > 500) {
this.count = 500;
}

    this.cardsService.getLastCardActivities(this.start, this.count, this.companiesFilter, this.str).subscribe(list => {
      this.list = [];
      list.forEach((v, i) => {
        v.description = v.description.replace(/\\/g, '\n');

        v.gpsPosData = parseGPSPosData(v.posData);

        this.list.push(v);
      });

      this.isLoading = false;
    });
  }

  ngOnInit(): void {

    this.companyService.getAll().subscribe(x => this.companies = x.data);

    this.searchTransactions();

  }

  isPinAuth(gpsPosData: GPSPosData|null) : boolean {
    if ( gpsPosData == null ) return false;
    return (gpsPosData.cardholderAuthMethod1) == AuthenticationMethod.PIN || (gpsPosData.cardholderAuthMethod2) == AuthenticationMethod.PIN || (gpsPosData.cardholderAuthMethod3) == AuthenticationMethod.PIN || (gpsPosData.cardholderAuthMethod4 ?? false) == AuthenticationMethod.PIN;
  }

  isSecure3DsAuth(gpsPosData: GPSPosData|null) : boolean {
    if ( gpsPosData == null ) return false;
    return (gpsPosData.cardholderAuthMethod1) == AuthenticationMethod.Secure3DS || (gpsPosData.cardholderAuthMethod2) == AuthenticationMethod.Secure3DS || (gpsPosData.cardholderAuthMethod3) == AuthenticationMethod.Secure3DS || (gpsPosData.cardholderAuthMethod4 ?? false) == AuthenticationMethod.Secure3DS;
  }

  isBiometricsAuth(gpsPosData: GPSPosData|null) : boolean {
    if ( gpsPosData == null ) return false;
    return (gpsPosData.cardholderAuthMethod1) == AuthenticationMethod.Biometrics || (gpsPosData.cardholderAuthMethod2) == AuthenticationMethod.Biometrics || (gpsPosData.cardholderAuthMethod3) == AuthenticationMethod.Biometrics || (gpsPosData.cardholderAuthMethod4 ?? false) == AuthenticationMethod.Biometrics;
  }

  protected readonly SCATestResult = SCATestResult;
  protected readonly CardholderPresent = CardholderPresent;
  protected readonly CardPresent = CardPresent;
  protected readonly CardDataInputMethod = CardDataInputMethod;
}
